import React from 'react';
import { Gift } from 'lucide-react';
import { Backdrop, Footer, FamilySwitcher } from './Layout';

// Shown at "/" — deliberately lists no families and redirects nowhere.
export default function Landing() {
  return (
    <Backdrop>
      <div className="bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="flex items-center justify-center mb-6">
          <FamilySwitcher><Gift className="w-12 h-12 text-red-500" /></FamilySwitcher>
        </div>
        <h1 className="text-3xl font-bold mb-4 text-gray-800">No Peeking</h1>
        <p className="text-gray-600">🎄 Use the link your family organizer sent you.</p>
      </div>
      <Footer />
    </Backdrop>
  );
}
